<template>
  <div>
    <div class="row vehicle-type-chart-header">
      <div class="col-md-12">
        <div class="chart-head-container">
          <h2>
            Miles Traveled by Vehicle
            <button v-tooltip title="This information is static and does not update" class="btn btn-tooltip ms-2"><font-awesome-icon icon="fa-solid fa-info-circle" /></button>
          </h2>
        </div>
      </div>
    <div class="vehicle-card col-md-6">
      <div class="vehicle-card-header">
        Freight
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Vocation</th>
            <th>Miles</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vehicle in freightVehicles" :key="vehicle.value">
            <td>{{vehicle.name}}</td>
            <td>{{vehicle.value.toLocaleString()}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="vehicle-card col-md-6">
      <div class="vehicle-card-header">
        Service
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Vocation</th>
            <th>Miles</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vehicle in serviceVehicles" :key="vehicle.value">
            <td>{{vehicle.name}}</td>
            <td>{{vehicle.value.toLocaleString()}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    <div class="row">
    <div class="vehicle-card col-md-6">
      <div class="vehicle-card-header">
       Passenger
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Vocation</th>
            <th>Miles</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vehicle in passengerVehicles" :key="vehicle.value">
            <td>{{vehicle.name}}</td>
            <td>{{vehicle.value.toLocaleString()}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="vehicle-card col-md-6">
      <div class="vehicle-card-header">
       Non-Road
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Vocation</th>
            <th>Miles</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vehicle in nonroadVehicles" :key="vehicle.value">
            <td>{{vehicle.name}}</td>
            <td>{{vehicle.value.toLocaleString()}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    </div>

  </div>
</template>

<script setup>

import { computed } from 'vue';

import { useStore } from 'vuex';

const store = useStore();

const freightVehicles = computed(() => store.getters.getFreightData);
const serviceVehicles = computed(() => store.getters.getServiceData);
const nonroadVehicles = computed(() => store.getters.getNonRoadData);
const passengerVehicles = computed(() => store.getters.getPassengerData);

</script>
